// InstaTextArea.jsx
import React from "react";
import { CopyButton } from "../../../../assets/components/ButtonGroup";

function getChannelLabel(channel) {
  const raw = String(channel || "").trim();

  // 인스타 계열
  if (raw === "3" || raw === 3 || raw === "인스타그램" || raw === "인스타 게시물") {
    return "인스타 게시물";
  }

  // 네이버 밴드 계열
  if (raw === "6" || raw === 6 || raw === "네이버밴드" || raw === "네이버 밴드") {
    return "네이버 밴드";
  }

  // 그 외에는 들어온 값 그대로
  return raw || "채널";
}

const InstaTextArea = ({ channel, value, onChange, toastBottomOffset }) => {
  const channelLabel = getChannelLabel(channel)

  return (

    <div className="pt-[24px] pb-[16px]">
      <div className="pb-[16px] flex items-center justify-between">
        <h2 className="text-t4 text-text-subtle ">{channelLabel}</h2>
        <CopyButton
          value={value}
          toastPlacement="bottom"
          toastBottomOffset={toastBottomOffset}
        />
      </div>
      <div className="relative border border-border-default rounded-[12px] py-[12px] px-[16px]">
        <textarea
          value={value}
          onChange={onChange}
          rows={10}
          className="w-full text-c2 text-text-subtle bg-surface-light-white focus:outline-none resize-none"
          placeholder="인스타 문구를 입력하세요"
        />

      </div>
    </div>
  );
}

export default InstaTextArea;